import { CONTACT } from "@/config/contact";
import PhotoFrame from "@/components/site/PhotoFrame";
import Reveal from "@/components/site/Reveal";
import SectionTitle from "@/components/site/SectionTitle";
import SiteButton from "@/components/site/SiteButton";

interface CtaSectionProps {
  onRequest: () => void;
}

/** Contact : e-mail, WhatsApp et appel (si un numéro est configuré), et la demande de compte. */
export default function CtaSection({ onRequest }: CtaSectionProps) {
  const digits = CONTACT.phone.replace(/\D/g, "");
  return (
    <section id="contact" className="scroll-mt-28 bg-background-100 py-20 md:py-28">
      <div className="mx-auto grid max-w-6xl items-center gap-12 px-4 md:px-6 lg:grid-cols-2 lg:gap-16">
        <div>
          <SectionTitle
            eyebrow="Nous écrire"
            title="Des questions avant de commencer ?"
            intro="Une démonstration, un doute sur le forfait ou sur la mise en place de votre école : écrivez-nous, c'est nous qui répondons."
          />

          <div className="mt-8 grid gap-4 sm:grid-cols-2">
            <Reveal className="h-full">
              <a
                href={`mailto:${CONTACT.email}`}
                className="group flex h-full flex-col rounded-[1.5rem] border border-background-200 bg-white p-6 transition-shadow hover:shadow-raised"
              >
                <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-primary-50 text-primary-700" aria-hidden="true">
                  <i className="ri-mail-line text-xl"></i>
                </span>
                <span className="mt-4 font-bold font-heading text-foreground-950">Par e-mail</span>
                <span className="mt-1 break-all text-sm text-foreground-600 group-hover:text-primary-700">{CONTACT.email}</span>
              </a>
            </Reveal>

            {digits && (
              <Reveal delay={80} className="h-full">
                <div className="flex h-full flex-col rounded-[1.5rem] border border-background-200 bg-white p-6">
                  <span className="font-bold font-heading text-foreground-950">Par téléphone</span>
                  <span className="mt-1 text-sm text-foreground-600">{CONTACT.phone}</span>
                  <div className="mt-auto flex flex-wrap gap-2 pt-4">
                    <SiteButton variant="primary" href={`https://wa.me/${digits}`} external icon="ri-whatsapp-line">
                      WhatsApp
                    </SiteButton>
                    <SiteButton variant="outline" href={`tel:+${digits}`} icon="ri-phone-line">
                      Appeler
                    </SiteButton>
                  </div>
                </div>
              </Reveal>
            )}
          </div>

          <div className="mt-8 flex flex-col gap-3 sm:flex-row">
            <SiteButton size="lg" onClick={onRequest} icon="ri-arrow-right-line">
              Demander un compte
            </SiteButton>
            <SiteButton size="lg" variant="outline" to="/suivre-demande">
              Suivre ma demande
            </SiteButton>
          </div>
        </div>

        <Reveal>
          <PhotoFrame
            src="/images/accueil-ordinateur.jpg"
            alt="Des élèves travaillent ensemble devant un ordinateur portable"
            caption="Sur ordinateur, tablette ou téléphone"
            className="aspect-[3/2] shadow-raised"
            imgClassName="object-[center_35%]"
          />
        </Reveal>
      </div>
    </section>
  );
}
